/** * * Asynchronously loads the component for
Privacy Policy
* */ import { lazyLoad } from "utils/loadable";
export const PrivacyPolicy = lazyLoad(
  () => import("./index"),
  (module) => module.PrivacyPolicy
);
